import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
import chessslogo from "../images/chessslogo.png";
import GameSummary from "./GameSummary";
import { connect } from "react-redux";
import { getScreams } from "../redux/actions/dataActions";
import EditProfile from "./EditProfile";
import ViewStats from "./ViewStats";
import { fetchGames } from "../util/api/game";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { ChessSocialContext } from "../util/ChessSocialContext";
import { fetchUserProfile } from "../util/api/user";
import ShareProfileModal from "../components/modals/ShareProfileModal";
import { usePremium } from '../util/PremiumFilter';
import { collection, query, where, getDocs, doc, updateDoc, writeBatch, deleteDoc, addDoc, getDoc, orderBy, limit } from "firebase/firestore";
import { firestore } from '../firebase';
import { fetchGame } from '../util/api/game';
import axios from 'axios';
import { cleanProfanity } from '../util/filterProfanity';
import { checkRateLimit } from '../util/rateLimiter';
import { getRateLimit, buildGlobalRateKey } from '../util/rateLimitConfig';
import RateLimitModal from '../components/modals/RateLimitModal';


// const edit = <EditProfile />;
// const stats = <ViewStats />;

const Profile = (props) => {
  const defaultFolders = [
    { folderName: 'Featured', isPrivate: false, games: [] },

  ];

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [folders, setFolders] = useState(defaultFolders);
  const [emptyFolderCount, setEmptyFolderCount] = useState(0); // Track number of empty folders
  const [nonEmptyFolders, setNonEmptyFolders] = useState([]); // Add missing state for non-empty folders
  const [hasFoldersWithGames, setHasFoldersWithGames] = useState(false); // Add missing state for tracking if there are folders with games

  const [gamesData, setGamesData] = useState([]);

  const editProfile = props.location.pathname == "/profile" ? true : false; // True when viewing own profile

  const { renderUserWithBadge, isPremiumUser } = usePremium();
  const user = editProfile ? props?.user?.credentials?.handle : props?.match?.params?.handle; // User handle
  // We only know the userId when viewing our own profile
  const userId = editProfile ? props?.user?.credentials?.userId : ""; // User Id, not known if viewing others' profile

  const authenticatedUserHandle = props?.user?.credentials?.handle; // Current logged-in user's handle
  const authenticatedUserId = props?.user?.credentials?.userId; // Current logged-in user's ID

  // Update the useEffect to fetch data when the component mounts
  // Fetch bookmark data when user changes or editProfile changes
  useEffect(() => {
    // console.log('useEffect for getData - user:', user, 'editProfile:', editProfile);
    if (user) {
      getData();
    }
  }, [user, editProfile]); // Re-fetch when user or editProfile changes

  const getData = async () => {
    // console.log('getData called for user:', user, 'editProfile:', editProfile);
    try {
      setIsLoading(true);
      setError(null);

      // For viewing own profile, use userId. For others, we need to get their userId first
      let targetUserIdForBookmarks = userId;
      
      if (!editProfile && user) {
        // OPTIMIZATION: Only query if we don't already have the user ID
        try {
          const userQuery = query(
            collection(firestore, "users"),
            where("handle", "==", user),
            limit(1) // Only need one result
          );
          const userSnapshot = await getDocs(userQuery);
          
          if (!userSnapshot.empty) {
            targetUserIdForBookmarks = userSnapshot.docs[0].data().userId;
          } else {
            setIsLoading(false);
            return;
          }
        } catch (error) {
          // console.error("Error fetching user for bookmarks:", error);
          setIsLoading(false);
          return;
        }
      }

      if (!targetUserIdForBookmarks) {
        setIsLoading(false);
        return;
      }

      // OPTIMIZATION: Fetch bookmark folders with limit
      const folderQuery = query(
        collection(firestore, "bookmarkFolders"),
        where("userId", "==", targetUserIdForBookmarks),
        where("isPrivate", "==", false),
        limit(50) // Reasonable limit to prevent excessive loading
      );

      const folderSnapshot = await getDocs(folderQuery);
      // console.log('Bookmark folders found:', folderSnapshot.size, 'for user:', user);


      let fetchedFolders = [];

      if (!folderSnapshot.empty) {
        // Process folder documents
        fetchedFolders = folderSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          // Ensure folderIndex exists, default to a high number for new folders
          folderIndex: doc.data().folderIndex !== undefined ? doc.data().folderIndex : 999
        }));
      } else {
      }
      // Ensure default folders exist
      let mergedFolders = [...fetchedFolders];

      // Check if Featured folder exists, if not add it
      if (!fetchedFolders.some(folder => folder.folderName === 'Featured')) {
        mergedFolders.push({
          folderName: 'Featured',
          isPrivate: false,
          games: [],
          userId: targetUserIdForBookmarks,
          folderIndex: 0 // Featured is always index 0 in public folders
        });
      } else {
        // Ensure Featured has index 0
        mergedFolders = mergedFolders.map(folder =>
          folder.folderName === 'Featured' ? { ...folder, folderIndex: 0 } : folder
        );
      }



      // Sort folders by folderIndex within their privacy category
      mergedFolders.sort((a, b) => {
        // First sort by privacy
        if (a.isPrivate !== b.isPrivate) {
          return a.isPrivate ? 1 : -1;
        }
        // Then sort by folderIndex
        return a.folderIndex - b.folderIndex;
      });


      setFolders(mergedFolders);

      // Filter folders for rendering - only show folders with games for all profiles
      const foldersWithGames = mergedFolders.filter(folder => {
        // For viewing others' profiles, show public folders that have games
        if (!editProfile) {
          return !folder.isPrivate && folder.games && Array.isArray(folder.games) && folder.games.length > 0;
        }
        // For own profile, only show folders that actually have games
        return folder.games && Array.isArray(folder.games) && folder.games.length > 0;
      });

      // Set state with filtered folders that have games
      setFolders(mergedFolders);
      setNonEmptyFolders(foldersWithGames);
      setHasFoldersWithGames(foldersWithGames.length > 0);
      // console.log('Final folders to display:', foldersWithGames.length, foldersWithGames.map(f => f.folderName));


      // Count empty folders (excluding default folders)
      const emptyCount = mergedFolders.filter(folder =>
        folder.folderName !== 'Featured' &&
        folder.folderName !== 'Safe' &&
        (!folder.games || folder.games.length === 0)
      ).length;
      setEmptyFolderCount(emptyCount);

      // Fetch game details for all bookmarked games
      const gameIds = new Set();
      mergedFolders.forEach(folder => {
        if (folder.games && Array.isArray(folder.games)) {
          folder.games.forEach(game => {
            gameIds.add(game.gameId);
          });
        }
      });


      // OPTIMIZATION: Only fetch game details if we have a reasonable number
      if (gameIds.size > 0 && gameIds.size <= 100) {
        await fetchBatchData(Array.from(gameIds));
      } else if (gameIds.size > 100) {
        // For large numbers of games, fetch only the first 100
        await fetchBatchData(Array.from(gameIds).slice(0, 100));
      }

      setIsLoading(false);
    } catch (error) {
      setError('Failed to load bookmarks. Please try again.');
      setIsLoading(false);
    }
  };

  const [activeTab, setActiveTab] = useState(''); // Start empty to trigger proper selection
  const [currentFolderGames, setCurrentFolderGames] = useState([]);

  const handleGameClick = (game) => {
    // Implement the logic to handle game click
  };

  const handleChallengeClick = (username) => {
    // Store the challenge username in sessionStorage so it doesn't persist to the next browser session
    // Using sessionStorage instead of localStorage ensures the data is cleared when the browser is closed
    sessionStorage.setItem('challengeUsername', username);

    // Set a flag to indicate that we should go to the Friends tab
    sessionStorage.setItem('openFriendsTab', 'true');

    // Set a timestamp so we can expire it if needed
    sessionStorage.setItem('challengeTimestamp', Date.now().toString());

    // Check if the user is authenticated with Lichess - this is a simplified check
    // The actual implementation would depend on how Lichess authentication is tracked in your app
    const isLichessAuthenticated = localStorage.getItem('lichessToken') || false;



    // Redirect to Play page with query parameters to ensure the UI updates correctly
    if (!isLichessAuthenticated) {
      // If not authenticated, go to the main Play page where they can authenticate first
      history.push(`/Play?challenge=${encodeURIComponent(username)}&tab=friends`);
    } else {
      // If authenticated, go directly to challenge with the username
      history.push(`/Play/${username}?tab=friends`);
    }
  };

  // const handleBlockUser = () => {
  //   if (isBlocked) {
  //     // If already blocked, show report alert
  //     alert(`User ${user} has been reported.`);
  //   } else {
  //     // If not blocked, block the user
  //     setIsBlocked(true);
  //     alert(`User ${user} has been blocked.`);
  //   }
  // };

  const fetchBatchData = useCallback(async (gameIds, folderName = null) => {
    if (!gameIds || gameIds.length === 0) return;

    try {
      // OPTIMIZATION: Process games in smaller batches to avoid overwhelming the server
      const batchSize = 10;
      const batches = [];
      
      for (let i = 0; i < gameIds.length; i += batchSize) {
        batches.push(gameIds.slice(i, i + batchSize));
      }

      const allGames = [];
      
      // Process batches sequentially to avoid rate limiting
      for (const batch of batches) {
        const gamePromises = batch.map(gameId => fetchGame(gameId));
        const gameResults = await Promise.allSettled(gamePromises);
        
        const batchGames = gameResults
          .filter(result => result.status === 'fulfilled')
          .map(result => result.value);
          
        allGames.push(...batchGames);
        
        // Small delay between batches to be respectful to the server
        if (batches.length > 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      if (folderName) {
        setCurrentFolderGames(allGames);
      } else {
        setGamesData(allGames);
      }
    } catch (error) {
      // console.error('Error fetching game data:', error);
    }
  }, []);

  // OPTIMIZATION: Memoize tab change handler to prevent unnecessary re-renders
  const handleTabChange = useCallback((tabName) => {
    setActiveTab(tabName);

    if (tabName === 'ALL GAMES') {
      setCurrentFolderGames([]);
      return;
    }

    const selectedFolder = folders.find(folder => folder.folderName === tabName);

    if (selectedFolder && selectedFolder.games && selectedFolder.games.length > 0) {
      const gameIds = selectedFolder.games.map(game => game.gameId);

      if (gameIds.length > 0) {
        fetchBatchData(gameIds, tabName);
      } else {
        setCurrentFolderGames([]);
      }
    } else {
      setCurrentFolderGames([]);
    }
  }, [folders, fetchBatchData]);


  // Debug information


  // Read user data using GET
  const [data, setData] = useState({});
  const fetchUserData = async () => {
    try {
      const result = await fetchUserProfile(user);
      setData(result.user);

      if (!user) {
        return;
      }

      // If user exists in the database
      if (result.user && typeof result.user !== "string") {
        // Fetch the user's document to get followers and following arrays
        const userQuery = query(
          collection(firestore, "users"),
          where("handle", "==", user)
        );

        const userSnapshot = await getDocs(userQuery);

        if (!userSnapshot.empty) {
          const userDoc = userSnapshot.docs[0];
          const userData = userDoc.data();

          // Store the target user ID for later use
          setTargetUserId(userDoc.id);

          // Get followers and following counts
          const followers = userData.followers || [];
          const following = userData.following || [];

          setFollowersCount(followers.length);
          setFollowingCount(following.length);

          // Store the actual lists of followers and following
          setFollowersList(followers);
          setFollowingList(following);

          // Check if current user is following this profile
          if (!editProfile && authenticatedUserHandle && authenticatedUserId) {
            const followStatus = await checkIfFollowing(user);
            setIsFollowing(followStatus);
          }
        } else {
          // Try a case-insensitive search
          const allUsersSnapshot = await getDocs(collection(firestore, "users"));
          const matchingUser = allUsersSnapshot.docs.find(doc =>
            doc.data().handle &&
            doc.data().handle.toLowerCase() === user.toLowerCase()
          );

          if (matchingUser) {
            const userData = matchingUser.data();
            setTargetUserId(matchingUser.id);

            // Get followers and following counts
            const followers = userData.followers || [];
            const following = userData.following || [];

            setFollowersCount(followers.length);
            setFollowingCount(following.length);

            // Store the actual lists of followers and following
            setFollowersList(followers);
            setFollowingList(following);

            // Check if current user is following this profile
            if (!editProfile && authenticatedUserHandle && authenticatedUserId) {
              const followStatus = await checkIfFollowing(user);
              setIsFollowing(followStatus);
            }
          } else {
            // console.error("User not found even with case-insensitive search:", user);
          }
        }
      } else {
      }
    } catch (error) {
      // console.error("Error fetching user:", error);
    }
  };

  // OPTIMIZATION: Reduce console logging and optimize fetchUserData calls
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // console.log("Profile component mounted:", { editProfile, user });
    }

    if (user) {
      checkUsersCollection();
      fetchUserData();
    }
  }, [user, authenticatedUserHandle, authenticatedUserId, editProfile]);

  let [games, setGames] = useState([]); // List of game objects
  const [isLoadingGames, setIsLoadingGames] = useState(true); // Add loading state
  const [isBlocked, setIsBlocked] = useState(false); // Track block state

  // Add new state variables for followers/following functionality
  const [isFollowing, setIsFollowing] = useState(false);
  const [isFollowLoading, setIsFollowLoading] = useState(false);
  const [followersCount, setFollowersCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [targetUserId, setTargetUserId] = useState("");

  // Add new state variables for followers/following dropdowns
  const [showFollowersDropdown, setShowFollowersDropdown] = useState(false);
  const [showFollowingDropdown, setShowFollowingDropdown] = useState(false);
  const [followersList, setFollowersList] = useState([]);
  const [followingList, setFollowingList] = useState([]);
  const [followersSearch, setFollowersSearch] = useState("");
  const [followingSearch, setFollowingSearch] = useState("");

  const { isSidebarCollapsed } = useContext(ChessSocialContext);
  const [showShareProfileModal, setShowShareProfileModal] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);

  const history = useHistory();
  const location = useLocation();

  // Redirect to /profile if viewing your own profile via /profile/username
  useEffect(() => {
    if (!editProfile && authenticatedUserHandle && user) {
      // Normalize both handles for comparison (remove @ if present, convert to lowercase)
      const normalizedAuthHandle = authenticatedUserHandle.replace('@', '').toLowerCase();
      const normalizedProfileHandle = user.replace('@', '').toLowerCase();


      if (normalizedAuthHandle === normalizedProfileHandle) {
        history.push('/profile');
      }
    }
  }, [editProfile, authenticatedUserHandle, user, history]);

  // Only check for non-existent users when viewing someone else's profile
  useEffect(() => {
    // Only check for non-existent users when viewing someone else's profile
    if (!editProfile && data !== undefined) {


      // Check if the returned data indicates user was not found
      if (data === "User not found" ||
        (typeof data === 'object' && data.user === "User not found")) {

        history.push('/profile');
      }
    }
  }, [editProfile, data, history]); // Only depend on editProfile, data, and history

  const fetchGamesForUser = async (gameLimit = 20, handle = "") => {
    try {
      setIsLoadingGames(true);

      if (!handle) {
        setGames([]);
        setIsLoadingGames(false);
        return;
      }

      // OPTIMIZATION: Try server-side filtering first, fall back to client-side if needed
      try {
        let filteredGames = [];
        
        try {
          // First attempt: server-side filtering
          const gamesQuery = query(
            collection(firestore, "games"),
            where("creator", "==", handle),
            orderBy("createdAt", "desc"),
            limit(gameLimit)
          );

          const gamesSnapshot = await getDocs(gamesQuery);
          
          gamesSnapshot.forEach(doc => {
            filteredGames.push({
              id: doc.id,
              ...doc.data()
            });
          });
          
          // console.log(`Server-side filtering found ${filteredGames.length} games for ${handle}`);
        } catch (serverError) {
          // console.warn("Server-side filtering failed, falling back to client-side:", serverError);
          
          // Fall back to client-side filtering with limited results
          const gamesQuery = query(
            collection(firestore, "games"),
            orderBy("createdAt", "desc"),
            limit(gameLimit * 5) // Get more results for client-side filtering
          );

          const gamesSnapshot = await getDocs(gamesQuery);
          const allGames = [];

          gamesSnapshot.forEach(doc => {
            allGames.push({
              id: doc.id,
              ...doc.data()
            });
          });

          // Filter games client-side with case-insensitive matching
          const normalizedHandle = handle.toLowerCase();
          filteredGames = allGames
            .filter(game => 
              game.creator && 
              game.creator.toLowerCase() === normalizedHandle
            )
            .slice(0, gameLimit);
            
          // console.log(`Client-side filtering found ${filteredGames.length} games for ${handle}`);
        }

        setGames(filteredGames);

      } catch (error) {
        console.error("Error querying games:", error);
        setGames([]);
      }

      setIsLoadingGames(false); // Set loading to false after fetching completes
    } catch (error) {

      setIsLoadingGames(false); // Set loading to false on error
      // Don't automatically redirect to Stats tab on error
    }
  };

  // OPTIMIZATION: Memoize fetchGamesForUser call and reduce dependencies
  useEffect(() => {
    if (user) {
      fetchGamesForUser(20, user);
    }
  }, [user]); // Remove hasFoldersWithGames dependency to prevent unnecessary refetches

  // Add these refs and effect at the component level
  const scrollContainerRef = React.useRef(null);
  const leftArrowRef = React.useRef(null);
  const rightArrowRef = React.useRef(null);

  React.useEffect(() => {
    const container = scrollContainerRef.current;
    const leftArrow = leftArrowRef.current;
    const rightArrow = rightArrowRef.current;

    const checkScroll = () => {
      if (container && leftArrow && rightArrow) { // Check if all refs exist
        const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
        if (leftArrow.style && rightArrow.style) { // Additional safety check
          leftArrow.style.display = hasHorizontalScroll ? 'block' : 'none';
          rightArrow.style.display = hasHorizontalScroll ? 'block' : 'none';
        }
      }
    };

    // Check on mount and window resize
    checkScroll();
    window.addEventListener('resize', checkScroll);

    // Cleanup
    return () => window.removeEventListener('resize', checkScroll);
  }, []); // Dependencies array remains empty

  // OPTIMIZATION: Memoize valid games calculation
  const validGames = useMemo(() => {
    return games.filter(game => game && Object.hasOwn(game, "id"));
  }, [games]);



  // Add these refs and effect at the component level
  const tabsLeftArrowRef = React.useRef(null); // Renamed for clarity
  const tabsRightArrowRef = React.useRef(null); // Renamed for clarity

  // Add new refs for game container and arrows
  const gamesScrollContainerRef = React.useRef(null);
  const gamesLeftArrowRef = React.useRef(null);
  const gamesRightArrowRef = React.useRef(null);

  // Add new ref for the bottom section
  const bottomLeftArrowRef = React.useRef(null);

  // OPTIMIZATION: Memoize scroll overflow check to reduce DOM queries
  const checkScrollOverflow = useCallback(() => {
    const tabsContainer = scrollContainerRef.current;
    const tabsLeftArrow = tabsLeftArrowRef.current;
    const tabsRightArrow = tabsRightArrowRef.current;

    if (tabsContainer && tabsLeftArrow && tabsRightArrow) {
      const hasTabsOverflow = tabsContainer.scrollWidth > tabsContainer.clientWidth;
      if (tabsLeftArrow.style && tabsRightArrow.style) {
        const arrowOpacity = hasTabsOverflow ? 1 : 0;
        tabsLeftArrow.style.opacity = arrowOpacity;
        tabsRightArrow.style.opacity = arrowOpacity;
        tabsLeftArrow.style.pointerEvents = hasTabsOverflow ? 'auto' : 'none';
        tabsRightArrow.style.pointerEvents = hasTabsOverflow ? 'auto' : 'none';
      }
    }

    const gamesContainer = gamesScrollContainerRef.current;
    const gamesLeftArrow = document.querySelector('.games-left-arrow');
    const gamesRightArrow = document.querySelector('.games-right-arrow');

    if (gamesContainer && gamesLeftArrow && gamesRightArrow) {
      const hasGamesOverflow = gamesContainer.scrollWidth > gamesContainer.clientWidth;
      const arrowOpacity = hasGamesOverflow ? 1 : 0;
      gamesLeftArrow.style.opacity = arrowOpacity;
      gamesRightArrow.style.opacity = arrowOpacity;
      gamesLeftArrow.style.pointerEvents = hasGamesOverflow ? 'auto' : 'none';
      gamesRightArrow.style.pointerEvents = hasGamesOverflow ? 'auto' : 'none';
    }

    const bottomLeftArrow = bottomLeftArrowRef.current;
    if (bottomLeftArrow && bottomLeftArrow.style) {
      bottomLeftArrow.style.opacity = 0;
      bottomLeftArrow.style.pointerEvents = 'none';
    }
  }, []);

  React.useEffect(() => {
    let timeoutId;
    
    checkScrollOverflow();
    
    // OPTIMIZATION: Use single ResizeObserver for all containers
    const resizeObserver = new ResizeObserver(() => {
      // Debounce the check to avoid excessive calls
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkScrollOverflow, 100);
    });

    const tabsContainer = scrollContainerRef.current;
    const gamesContainer = gamesScrollContainerRef.current;

    if (tabsContainer) resizeObserver.observe(tabsContainer);
    if (gamesContainer) resizeObserver.observe(gamesContainer);

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkScrollOverflow, 100);
    };
    
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timeoutId);
      if (tabsContainer) resizeObserver.unobserve(tabsContainer);
      if (gamesContainer) resizeObserver.unobserve(gamesContainer);
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, [checkScrollOverflow, isLoading, isLoadingGames]);


  // No need to create a separate gameList or shift the first game
  // We'll handle special styling in the render loop

  // Tab to navigate to
  const [tab, setTab] = useState("Default");
  const tabs = {
    Edit: <EditProfile />,
    Stats: <ViewStats handle={user} />, // Pass user handle for ViewStats page
  }
  // OPTIMIZATION: Memoize default active tab logic
  const setDefaultActiveTab = useCallback(() => {
    if (validGames.length > 0) {
      setActiveTab('ALL GAMES');
      return;
    }

    if (nonEmptyFolders.length > 0) {
      setActiveTab(nonEmptyFolders[0].folderName);
      return;
    }

    setActiveTab('ALL GAMES');
  }, [validGames.length, nonEmptyFolders]);

  // OPTIMIZATION: Reduce dependencies and improve logic
  useEffect(() => {
    if (!isLoadingGames && activeTab === '') {
      setDefaultActiveTab();
    }
  }, [isLoadingGames, activeTab, setDefaultActiveTab]);

  // OPTIMIZATION: Memoize folder data to prevent unnecessary re-fetches
  useEffect(() => {
    if (!activeTab || isLoadingGames) return;

    if (activeTab === 'ALL GAMES') {
      setCurrentFolderGames([]);
      return;
    }

    const selectedFolder = folders.find(folder => folder.folderName === activeTab);

    if (selectedFolder?.games?.length > 0) {
      const gameIds = selectedFolder.games.map(game => game.gameId);
      if (gameIds.length > 0) {
        fetchBatchData(gameIds, activeTab);
      } else {
        setCurrentFolderGames([]);
      }
    } else {
      setCurrentFolderGames([]);
    }
  }, [activeTab, folders, isLoadingGames, fetchBatchData]);

  // Function to check if current user is following the profile user
  const checkIfFollowing = async (targetUserHandle) => {
    try {
      if (!authenticatedUserId || !targetUserHandle || targetUserHandle === authenticatedUserHandle) {
        return false;
      }

      // IMPORTANT FIX: Update to use authenticatedUserHandle as the document ID, not authenticatedUserId
      const currentUserRef = doc(firestore, "users", authenticatedUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);

      if (!currentUserSnap.exists()) {
        // As a fallback, try to find the user document by querying for the handle


        const currentUserQuery = query(
          collection(firestore, "users"),
          where("handle", "==", authenticatedUserHandle)
        );

        const currentUserSnapshot = await getDocs(currentUserQuery);

        if (currentUserSnapshot.empty) {
          console.error("Could not find current user document");
          return false;
        }

        // Use the first matching document
        const userData = currentUserSnapshot.docs[0].data();
        const following = userData.following || [];

        // Use case-insensitive comparison
        const normalizedTargetHandle = targetUserHandle.toLowerCase();
        return following.some(handle => handle.toLowerCase() === normalizedTargetHandle);
      }

      const userData = currentUserSnap.data();
      const following = userData.following || [];

      // Use case-insensitive comparison
      const normalizedTargetHandle = targetUserHandle.toLowerCase();
      return following.some(handle => handle.toLowerCase() === normalizedTargetHandle);
    } catch (error) {
      console.error("Error checking follow status:", error);
      return false;
    }
  };

  // Function to follow a user
  const followUser = async (targetUserHandle) => {
    try {
      setIsFollowLoading(true);

      // Get current user info
      const currentUserHandle = authenticatedUserHandle;
      const currentUserId = authenticatedUserId;

      if (!currentUserHandle || !currentUserId) {
        alert("You must be logged in to follow users");
        setIsFollowLoading(false);
        return false;
      }

      // console.log("Follow attempt:", {
      //   currentUser: currentUserHandle,
      //   targetUser: targetUserHandle,
      //   targetUserId
      // });

      // We should already have the target user ID from fetchUserData,
      // if not, we'll try to find it
      let userTargetId = targetUserId;

      if (!userTargetId) {

        // Try to find the user with case-insensitive search
        const allUsersSnapshot = await getDocs(collection(firestore, "users"));
        const normalizedTargetHandle = targetUserHandle.toLowerCase();

        const matchingUser = allUsersSnapshot.docs.find(doc =>
          doc.data().handle &&
          doc.data().handle.toLowerCase() === normalizedTargetHandle
        );

        if (!matchingUser) {
          console.error("Target user not found with handle:", targetUserHandle);
          alert(`User "${targetUserHandle}" not found in the database.`);
          setIsFollowLoading(false);
          return false;
        }

        userTargetId = matchingUser.id;

      }

      if (!userTargetId) {
        console.error("Failed to determine target user ID");
        setIsFollowLoading(false);
        return false;
      }



      // Start a batch write
      const batch = writeBatch(firestore);

      // IMPORTANT FIX: Update to use currentUserHandle as the document ID, not currentUserId
      // This is because user documents are stored with handle as the ID, not the Firebase Auth UID
      const currentUserRef = doc(firestore, "users", currentUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);

      if (!currentUserSnap.exists()) {
        console.error("Current user document not found with handle:", currentUserHandle);

        // As a fallback, try to find the user document by querying for the handle
        const currentUserQuery = query(
          collection(firestore, "users"),
          where("handle", "==", currentUserHandle)
        );

        const currentUserSnapshot = await getDocs(currentUserQuery);

        if (currentUserSnapshot.empty) {
          console.error("Current user not found even with query by handle");
          setIsFollowLoading(false);
          return false;
        }

        // Use the first matching document
        const currentUserDoc = currentUserSnapshot.docs[0];
        const currentUserData = currentUserDoc.data();

        // Create or update the following array
        const following = currentUserData.following || [];

        // Check if already following (case-insensitive)
        const normalizedTargetHandle = targetUserHandle.toLowerCase();
        const alreadyFollowing = following.some(handle =>
          handle.toLowerCase() === normalizedTargetHandle
        );

        if (!alreadyFollowing) {
          // Store the handle exactly as it appears in their profile for consistency
          following.push(targetUserHandle);
          batch.update(doc(firestore, "users", currentUserDoc.id), { following });
        }
      } else {
        const currentUserData = currentUserSnap.data();

        // Create or update the following array
        const following = currentUserData.following || [];

        // Check if already following (case-insensitive)
        const normalizedTargetHandle = targetUserHandle.toLowerCase();
        const alreadyFollowing = following.some(handle =>
          handle.toLowerCase() === normalizedTargetHandle
        );

        if (!alreadyFollowing) {
          // Store the handle exactly as it appears in their profile for consistency
          following.push(targetUserHandle);
          batch.update(currentUserRef, { following });
        }
      }

      // Update target user's followers list
      const targetUserRef = doc(firestore, "users", userTargetId);
      const targetUserSnap = await getDoc(targetUserRef);

      if (!targetUserSnap.exists()) {
        console.error("Target user document not found with ID:", userTargetId);
        setIsFollowLoading(false);
        return false;
      }

      const targetUserData = targetUserSnap.data();

      // Create or update the followers array
      const followers = targetUserData.followers || [];

      // Check if already in followers (case-insensitive)
      const normalizedCurrentHandle = currentUserHandle.toLowerCase();
      const alreadyInFollowers = followers.some(handle =>
        handle.toLowerCase() === normalizedCurrentHandle
      );

      if (!alreadyInFollowers) {
        // Store the handle exactly as it appears in their profile for consistency
        followers.push(currentUserHandle);
        batch.update(targetUserRef, { followers });
      }

      // Commit the batch
      await batch.commit();

      // Create a follow notification
      await handleFollowNotification(targetUserHandle, true);


      setIsFollowLoading(false);
      return true;
    } catch (error) {
      console.error("Error following user:", error);
      alert("Failed to follow user. Please try again.");
      setIsFollowLoading(false);
      return false;
    }
  };

  // Function to unfollow a user
  const unfollowUser = async (targetUserHandle) => {
    try {
      setIsFollowLoading(true);

      // Get current user info
      const currentUserHandle = authenticatedUserHandle;
      const currentUserId = authenticatedUserId;

      if (!currentUserHandle || !currentUserId) {
        alert("You must be logged in to unfollow users");
        setIsFollowLoading(false);
        return false;
      }

      // console.log("Unfollow attempt:", {
      //   currentUser: currentUserHandle,
      //   targetUser: targetUserHandle,
      //   targetUserId
      // });

      // We should already have the target user ID from fetchUserData,
      // if not, we'll try to find it
      let userTargetId = targetUserId;

      if (!userTargetId) {

        // Try to find the user with case-insensitive search
        const allUsersSnapshot = await getDocs(collection(firestore, "users"));
        const normalizedTargetHandle = targetUserHandle.toLowerCase();

        const matchingUser = allUsersSnapshot.docs.find(doc =>
          doc.data().handle &&
          doc.data().handle.toLowerCase() === normalizedTargetHandle
        );

        if (!matchingUser) {
          console.error("Target user not found with handle:", targetUserHandle);
          alert(`User "${targetUserHandle}" not found in the database.`);
          setIsFollowLoading(false);
          return false;
        }

        userTargetId = matchingUser.id;

      }

      if (!userTargetId) {
        console.error("Failed to determine target user ID");
        setIsFollowLoading(false);
        return false;
      }



      // Start a batch write
      const batch = writeBatch(firestore);

      // IMPORTANT FIX: Update to use currentUserHandle as the document ID, not currentUserId
      // This is because user documents are stored with handle as the ID, not the Firebase Auth UID
      const currentUserRef = doc(firestore, "users", currentUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);

      if (!currentUserSnap.exists()) {
        console.error("Current user document not found with handle:", currentUserHandle);

        // As a fallback, try to find the user document by querying for the handle
        const currentUserQuery = query(
          collection(firestore, "users"),
          where("handle", "==", currentUserHandle)
        );

        const currentUserSnapshot = await getDocs(currentUserQuery);

        if (currentUserSnapshot.empty) {
          console.error("Current user not found even with query by handle");
          setIsFollowLoading(false);
          return false;
        }

        // Use the first matching document
        const currentUserDoc = currentUserSnapshot.docs[0];
        const currentUserData = currentUserDoc.data();

        // Update the following array - case insensitive filter
        const normalizedTargetHandle = targetUserHandle.toLowerCase();
        let following = currentUserData.following || [];
        following = following.filter(handle => handle.toLowerCase() !== normalizedTargetHandle);
        batch.update(doc(firestore, "users", currentUserDoc.id), { following });
      } else {
        const currentUserData = currentUserSnap.data();

        // Update the following array - case insensitive filter
        const normalizedTargetHandle = targetUserHandle.toLowerCase();
        let following = currentUserData.following || [];
        following = following.filter(handle => handle.toLowerCase() !== normalizedTargetHandle);
        batch.update(currentUserRef, { following });
      }

      // Update target user's followers list
      const targetUserRef = doc(firestore, "users", userTargetId);
      const targetUserSnap = await getDoc(targetUserRef);

      if (!targetUserSnap.exists()) {
        console.error("Target user document not found with ID:", userTargetId);
        setIsFollowLoading(false);
        return false;
      }

      const targetUserData = targetUserSnap.data();

      // Update the followers array - case insensitive filter
      const normalizedCurrentHandle = currentUserHandle.toLowerCase();
      let followers = targetUserData.followers || [];
      followers = followers.filter(handle => handle.toLowerCase() !== normalizedCurrentHandle);
      batch.update(targetUserRef, { followers });

      // Commit the batch
      await batch.commit();

      // Delete the follow notification
      await handleFollowNotification(targetUserHandle, false);


      setIsFollowLoading(false);
      return true;
    } catch (error) {
      console.error("Error unfollowing user:", error);
      alert("Failed to unfollow user. Please try again.");
      setIsFollowLoading(false);
      return false;
    }
  };

  // Function to handle follow/unfollow button click
  const handleFollowClick = async () => {
    if (isFollowLoading) return;

    try {
      // console.log("Follow button clicked. Current state:", {
      //   isFollowing,
      //   targetUserId,
      //   user,
      //   authenticatedUserHandle,
      //   authenticatedUserId
      // });

      if (!authenticatedUserHandle || !authenticatedUserId) {
        alert("You must be logged in to follow users");
        return;
      }

      if (!user) {
        alert("Unable to identify the user to follow");
        return;
      }

      // Check rate limit
      const userTier = isPremiumUser ? 'premium' : 'free';
      const config = getRateLimit('FOLLOW', userTier);
      const rateKey = buildGlobalRateKey(authenticatedUserId, 'follow');
      
      const isLimited = checkRateLimit({
        key: rateKey,
        limit: config.limit,
        windowMs: config.windowMs
      });

      if (isLimited) {
        setShowRateLimitModal(true);
        return;
      }

      if (isFollowing) {

        const success = await unfollowUser(user);
        if (success) {

          setIsFollowing(false);
          setFollowersCount(prev => Math.max(0, prev - 1));
          // OPTIMIZATION: Use requestAnimationFrame instead of setTimeout
          requestAnimationFrame(() => {
            refreshProfileData();
          });
        } else {
          console.error("Failed to unfollow user:", user);
        }
      } else {

        const success = await followUser(user);
        if (success) {

          setIsFollowing(true);
          setFollowersCount(prev => prev + 1);
          // OPTIMIZATION: Use requestAnimationFrame instead of setTimeout
          requestAnimationFrame(() => {
            refreshProfileData();
          });
        } else {
          console.error("Failed to follow user:", user);
        }
      }
    } catch (error) {
      console.error("Error handling follow click:", error);
      alert("An error occurred while trying to follow/unfollow. Please try again.");
    }
  };




  const handleFollowNotification = async (user, isFollowing) => {


    try {
      if (isFollowing) {
        // Add a new notification when following
        const docRef = await addDoc(collection(firestore, "notifications"), {
          type: "new_follower",
          followedBy: authenticatedUserHandle,
          followedTo: user,
          targetUser: user, // Add targetUser field for efficient querying
          status: "unread",
          timestamp: new Date()
        });

      } else {
        // Find and delete notification when unfollowing
        const notificationsQuery = query(
          collection(firestore, "notifications"),
          where("type", "==", "new_follower"),
          where("followedBy", "==", authenticatedUserHandle),
          where("followedTo", "==", user)
        );

        const notificationsSnapshot = await getDocs(notificationsQuery);

        if (!notificationsSnapshot.empty) {
          // Delete all matching notification documents (should typically be just one)
          const batch = writeBatch(firestore);

          notificationsSnapshot.forEach(doc => {
            batch.delete(doc.ref);
          });

          await batch.commit();

        } else {
        }
      }
    }
    catch (error) {
    }
  }

  // Function to check if the users collection exists and has the right structure
  const checkUsersCollection = async () => {
    try {
      // Check if the users collection exists
      const usersCollection = collection(firestore, "users");
      const snapshot = await getDocs(usersCollection);



      // Log some sample user data to help debug
      if (snapshot.size > 0) {
        const sampleUser = snapshot.docs[0].data();
        // console.log("Sample user data:", {
        //   id: snapshot.docs[0].id,
        //   hasFollowers: 'followers' in sampleUser,
        //   hasFollowing: 'following' in sampleUser,
        //   handle: sampleUser.handle || 'No handle field',
        //   fields: Object.keys(sampleUser)
        // });
      } else {
        console.warn("No users found in the database");
      }

      return snapshot.size > 0;
    } catch (error) {
      console.error("Error checking users collection:", error);
      return false;
    }
  };

  // Function to refresh data after a follow/unfollow action
  const refreshProfileData = async () => {
    try {

      await fetchUserData();
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  // Function to remove a follower (only for my own profile)
  const removeFollower = async (followerHandle) => {
    try {

      setIsFollowLoading(true);

      // Get current user info
      const currentUserHandle = authenticatedUserHandle;

      if (!currentUserHandle) {
        alert("You must be logged in to manage followers");
        setIsFollowLoading(false);
        return false;
      }

      // Start a batch write
      const batch = writeBatch(firestore);

      // Get the current user's document
      const currentUserRef = doc(firestore, "users", currentUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);

      // Find the follower's user document
      const followerQuery = query(
        collection(firestore, "users"),
        where("handle", "==", followerHandle)
      );

      const followerSnapshot = await getDocs(followerQuery);

      if (followerSnapshot.empty) {
        console.error("Follower not found with handle:", followerHandle);
        alert("Could not find the follower in the database.");
        setIsFollowLoading(false);
        return false;
      }

      const followerDoc = followerSnapshot.docs[0];
      const followerData = followerDoc.data();

      if (currentUserSnap.exists()) {
        const userData = currentUserSnap.data();

        // Remove follower from current user's followers list
        const normalizedFollowerHandle = followerHandle.toLowerCase();
        let followers = userData.followers || [];
        followers = followers.filter(handle => handle.toLowerCase() !== normalizedFollowerHandle);

        // Update current user's document
        batch.update(currentUserRef, { followers });

        // Remove current user from follower's following list
        const normalizedCurrentHandle = currentUserHandle.toLowerCase();
        let following = followerData.following || [];
        following = following.filter(handle => handle.toLowerCase() !== normalizedCurrentHandle);

        // Update follower's document
        batch.update(doc(firestore, "users", followerDoc.id), { following });

        // Commit the batch
        await batch.commit();

        // Delete the follow notification (follower was following the current user)
        await handleFollowNotification(currentUserHandle, false);

        // Update local state
        setFollowersList(followers);
        setFollowersCount(followers.length);


        setIsFollowLoading(false);
        return true;
      } else {
        console.error("Current user document not found");
        setIsFollowLoading(false);
        return false;
      }
    } catch (error) {
      console.error("Error removing follower:", error);
      alert("Failed to remove follower. Please try again.");
      setIsFollowLoading(false);
      return false;
    }
  };

  // Function to remove a user I'm following (only for my own profile)
  const removeFollowing = async (followingHandle) => {
    try {

      setIsFollowLoading(true);

      // Get current user info
      const currentUserHandle = authenticatedUserHandle;

      if (!currentUserHandle) {
        alert("You must be logged in to manage following");
        setIsFollowLoading(false);
        return false;
      }

      // Start a batch write
      const batch = writeBatch(firestore);

      // Get the current user's document
      const currentUserRef = doc(firestore, "users", currentUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);

      // Find the followed user's document
      const followedUserQuery = query(
        collection(firestore, "users"),
        where("handle", "==", followingHandle)
      );

      const followedUserSnapshot = await getDocs(followedUserQuery);

      if (followedUserSnapshot.empty) {
        console.error("Followed user not found with handle:", followingHandle);
        alert("Could not find the user in the database.");
        setIsFollowLoading(false);
        return false;
      }

      const followedUserDoc = followedUserSnapshot.docs[0];
      const followedUserData = followedUserDoc.data();

      if (currentUserSnap.exists()) {
        const userData = currentUserSnap.data();

        // Remove followingHandle from current user's following list
        const normalizedFollowingHandle = followingHandle.toLowerCase();
        let following = userData.following || [];
        following = following.filter(handle => handle.toLowerCase() !== normalizedFollowingHandle);

        // Update current user's document
        batch.update(currentUserRef, { following });

        // Remove current user from followed user's followers list
        const normalizedCurrentHandle = currentUserHandle.toLowerCase();
        let followers = followedUserData.followers || [];
        followers = followers.filter(handle => handle.toLowerCase() !== normalizedCurrentHandle);

        // Update followed user's document
        batch.update(doc(firestore, "users", followedUserDoc.id), { followers });

        // Commit the batch
        await batch.commit();

        // Delete the follow notification (current user was following the other user)
        await handleFollowNotification(followingHandle, false);

        // Update local state
        setFollowingList(following);
        setFollowingCount(following.length);


        setIsFollowLoading(false);
        return true;
      } else {
        console.error("Current user document not found");
        setIsFollowLoading(false);
        return false;
      }
    } catch (error) {
      console.error("Error removing following:", error);
      alert("Failed to remove following. Please try again.");
      setIsFollowLoading(false);
      return false;
    }
  };

  // Create refs for the dropdown elements
  const followersDropdownRef = useRef(null);
  const followingDropdownRef = useRef(null);

  // Add a unified function to handle dropdown toggling
  const toggleDropdown = (dropdownType) => {
    if (dropdownType === 'followers') {
      // If followers dropdown is already open, close it
      if (showFollowersDropdown) {
        setShowFollowersDropdown(false);
      }
      // If followers dropdown is closed
      else {
        // If following dropdown is open, close it first
        if (showFollowingDropdown) {
          setShowFollowingDropdown(false);
        }
        // Then open followers dropdown
        setShowFollowersDropdown(true);
      }
    }
    else if (dropdownType === 'following') {
      // If following dropdown is already open, close it
      if (showFollowingDropdown) {
        setShowFollowingDropdown(false);
      }
      // If following dropdown is closed
      else {
        // If followers dropdown is open, close it first
        if (showFollowersDropdown) {
          setShowFollowersDropdown(false);
        }
        // Then open following dropdown
        setShowFollowingDropdown(true);
      }
    }
  };

  // OPTIMIZATION: Memoize click outside handler and reduce dependency array
  const handleClickOutside = useCallback((event) => {
    if (
      showFollowersDropdown &&
      followersDropdownRef.current &&
      !followersDropdownRef.current.contains(event.target) &&
      !event.target.classList.contains('spanic-header-profile')
    ) {
      setShowFollowersDropdown(false);
    }

    if (
      showFollowingDropdown &&
      followingDropdownRef.current &&
      !followingDropdownRef.current.contains(event.target) &&
      !event.target.classList.contains('spanic-header-profile')
    ) {
      setShowFollowingDropdown(false);
    }
  }, [showFollowersDropdown, showFollowingDropdown]);

  useEffect(() => {
    if (showFollowersDropdown || showFollowingDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [handleClickOutside, showFollowersDropdown, showFollowingDropdown]);

  // Customize dropdown position based on screen size
  const getDropdownPosition = () => {
    // For mobile or smaller screens
    if (window.innerWidth < 768) {
      return {
        top: '130px',
        left: '50%',
        transform: 'translateX(-50%)'
      };
    }

    // For desktop/larger screens
    return {
      top: '50px',
      left: '50%',
      transform: 'translateX(-50%)'
    };
  };

  // OPTIMIZATION: Memoize sidebar state change handler and improve cleanup
  const handleSidebarStateChange = useCallback(() => {
    // Use requestAnimationFrame for better performance
    requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }, []);

  useEffect(() => {
    document.addEventListener('sidebarStateChanged', handleSidebarStateChange);
    return () => {
      document.removeEventListener('sidebarStateChanged', handleSidebarStateChange);
    };
  }, [handleSidebarStateChange]);

  // OPTIMIZATION: Improve URL parameter handling with proper cleanup
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    let timeoutId;

    if (tabParam && tabs[tabParam]) {
      setTab(tabParam);
      
      timeoutId = setTimeout(() => {
        window.history.replaceState(null, '', '/profile');
      }, 1000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [location.search, tabs]);

  // Helper function to get user data including premium level
  const getUserData = async (handle) => {
    try {
      const response = await axios.get(`/user/${handle}`);
      return response.data.user || null;
    } catch (error) {
      console.error(`Error fetching data for user ${handle}:`, error);
      return null;
    }
  };

  // State to store user data with premium info
  const [userData, setUserData] = useState(null);
  const [followerData, setFollowerData] = useState({});
  const [followingData, setFollowingData] = useState({});

  // Fetch user data when profile loads
  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const data = await getUserData(user);
        if (data) {
          setUserData(data);
        }
      }
    };

    fetchUserData();
  }, [user]);

  // Fetch follower data when followers list changes
  useEffect(() => {
    const fetchFollowerData = async () => {
      const newData = {};
      for (const handle of followersList) {
        if (!followerData[handle]) {
          const data = await getUserData(handle);
          if (data) {
            newData[handle] = data;
          }
        }
      }

      if (Object.keys(newData).length > 0) {
        setFollowerData(prev => ({ ...prev, ...newData }));
      }
    };

    if (followersList.length > 0) {
      fetchFollowerData();
    }
  }, [followersList]);

  // Fetch following data when following list changes
  useEffect(() => {
    const fetchFollowingData = async () => {
      const newData = {};
      for (const handle of followingList) {
        if (!followingData[handle]) {
          const data = await getUserData(handle);
          if (data) {
            newData[handle] = data;
          }
        }
      }

      if (Object.keys(newData).length > 0) {
        setFollowingData(prev => ({ ...prev, ...newData }));
      }
    };

    if (followingList.length > 0) {
      fetchFollowingData();
    }
  }, [followingList]);

  // Add state for the unsaved changes confirmation modal
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [pendingTabChange, setPendingTabChange] = useState(null);

  // Handle Main Profile tab click with unsaved changes check
  const handleMainProfileClick = () => {
    
    
    

    // If we're in the Edit tab and there are unsaved changes, show confirmation
    if (tab === "Edit" && window.editProfileHasUnsavedChanges) {
      
      // Store the pending tab change
      setPendingTabChange("Default");

      // Show confirmation modal
      setShowUnsavedChangesModal(true);
      
    } else {
      
      // No unsaved changes, proceed with tab change
      setTab("Default");
    }
  };

  // Handle confirming unsaved changes (Save button)
  const handleSaveChanges = () => {
    
    
    // First, check if there are validation errors
    const checkForValidationErrors = () => {
      // Check for global error flag first
      if (window.editProfileHasValidationErrors) {
        
        return true;
      }
      // Check if EditProfile component has any error messages displayed
      const errorMessages = document.querySelectorAll('.edit-profile-container [style*="color: #ff0000"]');
      return errorMessages.length > 0;
    };
    
    const hasErrors = checkForValidationErrors();
    
    // Close our modal regardless of errors
    setShowUnsavedChangesModal(false);
    
    
    if (hasErrors) {
      
      // If there are errors, don't proceed with tab change
      setPendingTabChange(null);
      return;
    }

    // Find the EditProfile component's save button and click it
    const saveButton = document.querySelector('.edit-profile-container button');
    
    if (saveButton) {
      
      saveButton.click();
      
      // OPTIMIZATION: Use requestAnimationFrame for better performance
      let timeoutId = setTimeout(() => {
        const stillHasErrors = checkForValidationErrors();
        if (stillHasErrors) {
          setPendingTabChange(null);
          return;
        }
        
        if (pendingTabChange) {
          setTab(pendingTabChange);
          setPendingTabChange(null);
        }
      }, 300);
      
      // Store timeout ID for potential cleanup
      return () => clearTimeout(timeoutId);
    } else {
      // If save button not found, we can proceed with tab change
      if (pendingTabChange) {
        
        setTab(pendingTabChange);
        setPendingTabChange(null);
      }
    }
  };

  // Handle discarding unsaved changes (Don't Save button)
  const handleDiscardChanges = () => {
    

    // Check if there are validation errors still showing
    const hasErrors = document.querySelectorAll('.edit-profile-container [style*="color: #ff0000"]').length > 0 || 
                      window.editProfileHasValidationErrors;
    
    // Close modal
    setShowUnsavedChangesModal(false);

    // If there are errors, just close the modal and stay on the edit page
    if (hasErrors) {
      
      setPendingTabChange(null);
      return;
    }

    // Reset the global unsaved changes flag
    window.editProfileHasUnsavedChanges = false;
    

    // Execute the pending tab change
    if (pendingTabChange) {
      
      setTab(pendingTabChange);
      setPendingTabChange(null);
    }
  };

  return (
    <div className="app-container" >

      <div className="explore-container main-column" style={{
        maxWidth: isSidebarCollapsed ? 'calc(100vw - 125px)' : 'calc(100vw - 250px)',
        width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'
      }}>
        <header className="header-profile">
          <div className="header-profile-left" style={{ }}>
            <div className="profile-picture-container" style={{ 
              width: "100px", 
              height: "100px", 
              borderRadius: "50%",
              overflow: "hidden",
              border: "3px solid gold",
              boxShadow: "0 0 15px rgba(255, 215, 0, 0.3)",
              backgroundColor: "#121212",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "20px"
            }}>
              <img
                src={data && data.photoUrl ? data.photoUrl : chessslogo}
                alt={`${user}'s profile`}
                style={{ 
                  width: "100%", 
                  height: "100%", 
                  objectFit: "cover" 
                }}
              />
            </div>
            <div className="right-div-profile-inside">
              <div className="first-div-profile-header" style={{ letterSpacing: '1px', color: 'gold', fontSize: '30px' }}>
                <span className="" >{userData ? renderUserWithBadge(user, userData.premium, false) : renderUserWithBadge(user, false)}</span>
                {/* <span className="" style={{ border: '1px solid gold', padding: '2px 15px', borderRadius: '0px 15px' }}>2123</span> */}

              </div>

              
              <div className="paragraph-header-profile" >
                {data.status}
              </div>

              {/* Followers Dropdown */}
              {showFollowersDropdown && (
                <div
                  ref={followersDropdownRef}
                  style={{
                    ...getDropdownPosition(),
                    position: 'absolute',
                    width: '250px',
                    backgroundColor: '#121212',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    border: '2px solid gold',
                    borderRadius: '8px',
                    zIndex: 1000,
                    padding: '15px'
                  }}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                    borderBottom: '1px solid gold',
                    paddingBottom: '5px'
                  }}>
                    <h3 style={{ margin: 0, color: 'gold' }}>Followers</h3>
                    <button
                      onClick={() => toggleDropdown('followers')}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: 'gold',
                        fontSize: '18px',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fa-solid fa-times"></i>
                    </button>
                  </div>

                  <div style={{
                    maxHeight: '250px',
                    overflowY: 'auto',
                    marginBottom: '10px'
                  }}>
                    <div style={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <input
                        type="text"
                        value={followersSearch}
                        onChange={(e) => setFollowersSearch(e.target.value)}
                        placeholder="Search..."
                        style={{
                          padding: '8px',
                          paddingLeft: '30px',
                          border: '1px solid #333',
                          borderRadius: '4px',
                          backgroundColor: '#222',
                          color: 'white',
                          fontSize: '14px',
                          marginTop: '10px',
                          width: '83%',
                          marginBottom: '10px'
                        }}
                      />
                      <i
                        className="fa-solid fa-magnifying-glass"
                        style={{
                          position: 'absolute',
                          left: '15px',
                          top: '19px',
                          color: '#aaa',
                          fontSize: '14px'
                        }}
                      />
                    </div>
                    {followersList.length === 0 ? (
                      <div style={{ color: '#aaa', textAlign: 'center', padding: '10px' }}>
                        No followers yet
                      </div>
                    ) : (
                      followersList
                        .filter(handle => handle.toLowerCase().includes(followersSearch.toLowerCase()))
                        .map((handle, index) => (
                          <div
                            key={index}
                            style={{
                              padding: '8px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #333',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#333'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          >
                            <div
                              onClick={() => {
                                history.push(`/profile/${handle}`);
                                toggleDropdown('followers');
                              }}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexGrow: 1
                              }}
                            >
                              {/* <i className="fa-solid fa-user" style={{ marginRight: '10px', color: 'gold' }}></i> */}
                              {followerData[handle] ?
                                renderUserWithBadge(handle, followerData[handle].premium) :
                                renderUserWithBadge(handle)}
                            </div>

                            {/* Show X button only on own profile */}
                            {editProfile && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent triggering the parent click
                                  if (window.confirm(`Remove ${handle} from your followers?`)) {
                                    removeFollower(handle);
                                  }
                                }}
                                style={{
                                  background: 'transparent',
                                  border: 'none',
                                  color: 'gray',
                                  fontSize: '16px',
                                  cursor: 'pointer',
                                  padding: '0 5px',
                                  marginLeft: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                                title="Remove follower"
                              >
                                <i className="fa-solid fa-times"></i>
                              </button>
                            )}
                          </div>
                        ))
                    )}
                  </div>


                </div>
              )}

              {/* Following Dropdown */}
              {showFollowingDropdown && (
                <div
                  ref={followingDropdownRef}
                  style={{
                    ...getDropdownPosition(),
                    position: 'absolute',
                    width: '250px',
                    backgroundColor: '#121212',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    border: '2px solid gold',
                    borderRadius: '8px',
                    zIndex: 1000,
                    padding: '15px'
                  }}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                    borderBottom: '1px solid gold',
                    paddingBottom: '5px',
                  }}>
                    <h3 style={{ margin: 0, color: 'gold' }}>Following</h3>
                    <button
                      onClick={() => toggleDropdown('following')}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: 'gold',
                        fontSize: '18px',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fa-solid fa-times"></i>
                    </button>
                  </div>

                  <div style={{
                    maxHeight: '250px',
                    overflowY: 'auto',
                    marginBottom: '10px'
                  }}>
                    <div style={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <input
                        type="text"
                        value={followingSearch}
                        onChange={(e) => setFollowingSearch(e.target.value)}
                        placeholder="Search..."
                        style={{
                          padding: '8px',
                          paddingLeft: '30px',
                          border: '1px solid #333',
                          borderRadius: '4px',
                          backgroundColor: '#222',
                          color: 'white',
                          fontSize: '14px',
                          marginTop: '10px',
                          width: '83%',
                          marginBottom: '10px'
                        }}
                      />
                      <i
                        className="fa-solid fa-magnifying-glass"
                        style={{
                          position: 'absolute',
                          left: '15px',
                          top: '19px',
                          color: '#aaa',
                          fontSize: '14px'
                        }}
                      />
                    </div>
                    {followingList.length === 0 ? (
                      <div style={{ color: '#aaa', textAlign: 'center', padding: '10px' }}>
                        Not following anyone yet
                      </div>
                    ) : (
                      followingList
                        .filter(handle => handle.toLowerCase().includes(followingSearch.toLowerCase()))
                        .map((handle, index) => (
                          <div
                            key={index}
                            style={{
                              padding: '8px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #333',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#333'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          >
                            <div
                              onClick={() => {
                                history.push(`/profile/${handle}`);
                                toggleDropdown('following');
                              }}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexGrow: 1
                              }}
                            >
                              {/* <i className="fa-solid fa-user" style={{ marginRight: '10px', color: 'gold' }}></i> */}
                              {followingData[handle] ?
                                renderUserWithBadge(handle, followingData[handle].premium) :
                                renderUserWithBadge(handle)}
                            </div>

                            {/* Show X button only on own profile */}
                            {editProfile && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent triggering the parent click
                                  if (window.confirm(`Unfollow ${handle}?`)) {
                                    removeFollowing(handle);
                                  }
                                }}
                                style={{
                                  background: 'transparent',
                                  border: 'none',
                                  color: 'gray',
                                  fontSize: '16px',
                                  cursor: 'pointer',
                                  padding: '0 5px',
                                  marginLeft: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                                title="Unfollow"
                              >
                                <i className="fa-solid fa-times"></i>
                              </button>
                            )}
                          </div>
                        ))
                    )}
                  </div>


                </div>
              )}

            </div>

          </div>

          <div className="header-profile-right" style={{ marginRight: '70px' }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              width: '100%',
              padding: '0',
              gap: '15px',
            }}>

              <div className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', justifyContent: 'flex-end', width: '', padding: '0', gap: '15px', marginRight: '20px' }}>
                <span className="spanic-header-profile">{games.length} {games.length === 1 ? 'Post' : 'Posts'}</span>
                {/* <div className="border-line"></div> */}
                <span
                  className="spanic-header-profile"
                  onClick={() => toggleDropdown('followers')}
                  style={{ cursor: 'pointer' }}
                >
                  {followersCount} {followersCount === 1 ? 'Follower' : 'Followers'}
                </span>
                {/* <div className="border-line"></div> */}
                <span
                  className="spanic-header-profile"
                  onClick={() => toggleDropdown('following')}
                  style={{ cursor: 'pointer' }}
                >
                  {followingCount} {followingCount === 1 ? 'Following' : 'Following'}
                </span>
              </div>

              {/* Action buttons */}
              {!editProfile && user !== authenticatedUserHandle ? (
                /* Other user's profile - Follow and Challenge buttons side by side */
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                    <button
                      className="Profile-buttons"
                      style={{
                        height: '50px',
                        backgroundColor: isFollowing ? 'transparent' : 'gold',
                        color: isFollowing ? 'gold' : 'black',
                        border: isFollowing ? '2px solid gold' : '2px solid gold',
                        opacity: isFollowLoading ? 0.7 : 1,
                        cursor: isFollowLoading ? 'default' : 'pointer',
                        width: '150px',
                        fontSize: '16px'
                      }}
                      onClick={handleFollowClick}
                      disabled={isFollowLoading}
                    >
                      {isFollowLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        isFollowing ? "Unfollow" : "Follow"
                      )}
                    </button>
                   {/*} <button
                      className="Profile-buttons"
                      onClick={() => handleChallengeClick(user)}
                      style={{
                        height: '50px',
                        width: '150px',
                        fontSize: '16px',
                        color: 'black',
                        border: '2px solid #57b047',
                        background: '#57b047'
                      }}
                    >
                      Challenge
                    </button> */}
                    <button
                      className="Profile-buttons"
                      style={{
                        height: '50px',
                        backgroundColor: 'gold',
                        color: 'black',
                        border: '2px solid gold',
                        cursor: 'pointer',
                        width: '150px',
                        fontSize: '16px'
                      }}
                      onClick={() => {
                        // Get the base URL of the site
                        const baseUrl = window.location.origin;
                        // Use the actual user handle from the profile being viewed
                        const profileHandle = user;
                        // Generate a direct URL to the specific profile
                        const shareUrl = `${baseUrl}/profile/${profileHandle}`;
                        setShowShareProfileModal(true);
                        setShareLink(shareUrl);
                      }}
                    >
                      Share
                      <i className="fa-regular fa-paper-plane" style={{ marginLeft: '8px' }}></i>
                    </button>
                  </div>
                </>
              ) : (
                /* Player's own profile - Edit Profile button */
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                    <button
                    className="Profile-buttons"
                    style={{
                      height: '50px',
                      backgroundColor: tab == "Edit" ? 'transparent' : 'gold',
                      color: tab == "Edit" ? 'gold' : 'black',
                      border: '2px solid gold',
                      cursor: 'pointer',
                      width: '150px',
                      fontSize: '16px'
                    }}
                    onClick={() => {
                      
                      if (tab == "Edit") {
                        
                        handleMainProfileClick();
                      } else {
                        
                        setTab("Edit");
                      }
                    }}
                  >
                    {tab == "Edit" ? "Main Profile" : "Edit Profile"}
                  </button>
                  <button
                    className="Profile-buttons"
                    style={{
                      height: '50px',
                      backgroundColor: 'gold',
                      color: 'black',
                      border: '2px solid gold',
                      cursor: 'pointer',
                      width: '150px',
                      fontSize: '16px'
                    }}
                    onClick={() => {
                      // Get the base URL of the site
                      const baseUrl = window.location.origin;
                      // Use the actual user handle from the profile being viewed
                      const profileHandle = user;
                      // Generate a direct URL to the specific profile
                      const shareUrl = `${baseUrl}/profile/${profileHandle}`;
                      setShowShareProfileModal(true);
                      setShareLink(shareUrl);
                    }}
                  >
                    Share
                    <i className="fa-regular fa-paper-plane" style={{ marginLeft: '8px' }}></i>
                  </button>
                  </div>

                  {/* Unsaved Changes Confirmation Modal */}
                  {(() => {
                    
                    return showUnsavedChangesModal && (
                      <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                      }}>
                        <div style={{
                          backgroundColor: '#121220',
                          borderRadius: '10px',
                          padding: '30px',
                          maxWidth: '500px',
                          width: '90%',
                          boxShadow: '0 0 30px rgba(255, 215, 0, 0.3)',
                          border: '2px solid rgba(255, 215, 0, 0.5)',
                        }}>
                          <h2 style={{
                            color: 'gold',
                            fontSize: '24px',
                            marginBottom: '20px',
                            textAlign: 'center'
                          }}>
                            <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '10px' }}></i>
                            Unsaved Changes
                          </h2>

                          <p style={{
                            color: 'white',
                            fontSize: '16px',
                            lineHeight: '1.5',
                            marginBottom: '25px',
                            textAlign: 'center'
                          }}>
                            You have unsaved changes to your profile. Would you like to save them before leaving?
                          </p>

                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '15px',
                            marginBottom: '15px' // Add margin to separate the button rows
                          }}>
                            <button
                              onClick={handleDiscardChanges}
                              id="discardChangesBtn"
                              style={{
                                padding: '12px 20px',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                color: 'white',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                fontSize: '16px',
                                cursor: 'pointer',
                                flex: 1,
                                transition: 'all 0.3s ease'
                              }}
                            >
                              Don't Save
                            </button>
                            <button
                              onClick={handleSaveChanges}
                              id="saveChangesBtn"
                              style={{
                                padding: '12px 20px',
                                backgroundColor: '#ff0050',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                fontSize: '16px',
                                cursor: 'pointer',
                                flex: 1,
                                transition: 'all 0.3s ease'
                              }}
                            >
                              Save Changes
                            </button>

                            
                          </div>
                          
                          {/* Continue Editing Button */}
                          <button
                            onClick={() => setShowUnsavedChangesModal(false)}
                            style={{
                              padding: '14px 20px',
                              backgroundColor: 'rgba(255, 215, 0, 0.15)',
                              color: '#ffd700',
                              border: '2px solid rgba(255, 215, 0, 0.6)',
                              borderRadius: '5px',
                              fontWeight: 'bold',
                              fontSize: '16px',
                              cursor: 'pointer',
                              width: '100%',
                              transition: 'all 0.3s ease',
                              display: 'block',
                            }}
                          >
                            <i className="fa-solid fa-pencil" style={{ marginRight: '8px' }}></i>
                            Continue Editing
                          </button>
                        </div>
                      </div>
                    );
                  })()}
                </>
              )}

              {/* Player Stats button - consistent for all profiles */}
              {/* <button
                className="Profile-buttons"
                style={{
                  height: '110px',
                  fontSize: '26px',
                  color: tab == "Stats" ? '#ff0000' : 'gold',
                  border: tab == "Stats" ? '2px solid red' : '2px solid gold',
                  background: '#121212',
                  width: '175px',
                  fontFamily: 'Mansalva, cursive'
                }}
                onClick={() => {
                  if (tab == "Stats") {
                    setTab("Default");
                  } else {
                    setTab("Stats");
                  }
                }}
              >            {tab == "Stats" ? <i className={`fa-solid ${tab == "Stats" ? 'fa-chess-king' : 'fa-chess-board'}`} style={{ color: tab == "Stats" ? '#ff0000' : 'gold', marginRight: '10px', lineHeight: '1.5', letterSpacing: '5px', }}><span style={{ fontFamily: 'Mansalva, cursive' }}>Main Profile</span></i> : ''}

                {tab == "Default" ? <span style={{ textAlign: 'left' }}><span style={{ color: tab == "Default" ? 'gold' : 'gold', marginRight: '10px', lineHeight: '1.5', letterSpacing: '5px' }}>Player Stats</span><i className={`fa-solid ${tab == "Default" ? 'fa-chess-pawn' : 'fa-chess-board'}`} style={{ color: tab == "Default" ? 'gold' : 'gold', lineHeight: '1.5', letterSpacing: '10px' }}></i></span> : ''}
                {tab == "Edit" ? <span style={{ textAlign: 'left' }}><span style={{ color: tab == "Default" ? 'gold' : 'gold', marginRight: '10px', lineHeight: '1.5', letterSpacing: '5px' }}>Player Stats</span><i className={`fa-solid ${tab == "Default" ? 'fa-chess-pawn' : 'fa-chess-pawn'}`} style={{ color: tab == "Default" ? 'gold' : 'gold', lineHeight: '1.5', letterSpacing: '10px' }}></i></span> : ''}

              </button> */}

              {/* Social media icons in a responsive layout */}
              <div style={{
                display: (() => {
                  const iconCount = [data.youtubeLink, data.tiktokLink, data.instagramLink, data.twitterLink].filter(Boolean).length;
                  return iconCount <= 2 ? 'flex' : 'grid';
                })(),
                gridTemplateColumns: 'repeat(2, 1fr)',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                justifyItems: 'center',
                gap: '15px',
                marginLeft: '10px',
                fontSize: '30px',
                maxWidth: (() => {
                  const iconCount = [data.youtubeLink, data.tiktokLink, data.instagramLink, data.twitterLink].filter(Boolean).length;
                  return iconCount <= 2 ? 'none' : '100px';
                })()
              }}>
                {/* YouTube */}
                {data.youtubeLink ? (
                  <a href={data.youtubeLink} target="_blank" rel="noopener noreferrer" style={{}}>
                    <i className="fa-brands fa-youtube" style={{ fontSize: '36px', color: 'white' }}></i>
                  </a>
                ) : (
                  <></>
                )}

                {/* TikTok */}
                {data.tiktokLink ? (
                  <a href={data.tiktokLink} target="_blank" rel="noopener noreferrer" style={{}}>
                    <i className="fa-brands fa-tiktok" style={{ fontSize: '36px', color: 'white' }}></i>
                  </a>
                ) : (
                  <></>
                )}

                {/* Instagram */}
                {data.instagramLink ? (
                  <a href={data.instagramLink} target="_blank" rel="noopener noreferrer" style={{}}>
                    <i className="fa-brands fa-instagram" style={{ fontSize: '36px', color: 'white' }}></i>
                  </a>
                ) : (
                  <></>
                )}

                {/* Facebook */}
                {data.twitterLink ? (
                  <a
                    href={data.twitterLink.startsWith('http') ? data.twitterLink : `https://${data.twitterLink}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{}}>
                    <div className='icon'>
                      <i className="fa-brands fa-x-twitter" style={{ fontSize: '36px', color: 'white' }}></i>
                    </div>
                  </a>
                ) : null}


              </div>
            </div>
          </div>
        </header>

        <main className="main-profile" style={{
          overflow: 'auto',
          paddingBottom: '10px',
          width: '100%',
          boxSizing: 'border-box',
          marginTop: '',
        }}>

          {tab == "Default" ? (
            <div style={{
              maxWidth: isSidebarCollapsed ? 'calc(100vw - 175px)' : 'calc(100vw - 300px)',
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              flexWrap: 'wrap',
              overflow: 'hidden'
            }}>
              

              <div style={{
                position: 'relative',
                width: '100%',
                maxWidth: '100%',
                margin: '0 auto',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: '500px',
                overflow: 'hidden'
              }}>
                {data.biography && (
                  <> 
                {/* Bio Card */}
                <div style={{
                    padding: '0px 25px',
                    background: 'linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)',
                    borderRadius: '15px',
                    border: '1px solid rgba(255,255,255,0.2)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
                    margin: '20px 50px'
                  }}>
                    <h2 style={{
                      fontSize: '24px',
                      color: 'gold',
                  
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      Biography
                    </h2>
                    <p style={{
                      fontSize: '18px',
                      lineHeight: '1.6',
                      color: 'white',
                      fontStyle: 'italic',
                      paddingBottom: '10px',
                    }}>

                      {data.biography ? data.biography : "Still working on it..."}
                    </p>
                    </div>
                  </>
                )}


                <div style={{}}>
                  {(validGames.length > 0 || nonEmptyFolders.length > 0) && (
                    <div style={{
                      position: 'relative',
                      width: '100%',
                      maxWidth: '100%',
                      margin: '5px auto',
                      display: 'flex',
                      alignItems: 'center',
                      height: '45px', // Increased height slightly
                      boxSizing: 'border-box',
                      justifyContent: 'center', // Center the entire tab container
                    }}>
                      <div
                        ref={tabsLeftArrowRef}
                        style={{
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          marginRight: '10px', // Add space between arrow and tabs
                          minWidth: '40px', // Give it a fixed width
                          justifyContent: 'center',
                          transition: 'opacity 0.3s ease', // Smooth transition for opacity
                          opacity: 1, // Start visible, will be updated by effect
                        }}
                      >
                        <button
                          style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#ffd700',
                            fontSize: '1.5rem',
                            padding: '0 10px',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            const container = document.querySelector('.tabs-scroll-container');
                            container.scrollTo({ left: 0, behavior: 'smooth' });
                          }}
                        >
                          <i className="fa-solid fa-chevron-left"></i>
                        </button>

                      </div>

                      <div
                        className="tabs-container-wrapper"
                        style={{
                          position: 'relative',
                          height: '100%',
                          flex: '1',
                          maxWidth: 'calc(100% - 100px)', // Reserve space for arrows
                          overflow: 'hidden' // Hide overflow
                        }}
                      >
                        <div
                          className="tabs-scroll-container"
                          ref={scrollContainerRef}
                          style={{
                            display: 'flex',
                            overflowX: 'auto',
                            scrollBehavior: 'smooth',
                            gap: '5px',
                            height: '85%',
                            width: '100%',
                            alignItems: 'center',
                            msOverflowStyle: 'none',
                            scrollbarWidth: 'none',

                            position: 'relative', // For positioning the borders
                            '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar
                            borderTop: '3px solid #ffd700',    // Changed to direct border
                            // borderBottom: '3px solid #ffd700'  // Changed to direct border
                          }}
                        >{ }
                          {[
                            // Only show ALL GAMES tab if there are games
                            ...(validGames.length > 0 ? ['ALL GAMES'] : []),

                            // Only show folders that have games
                            ...nonEmptyFolders.map(folder => folder.folderName)
                          ].map((tab) => (
                            <button
                              key={tab}
                              className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                              onClick={() => handleTabChange(tab)}
                              style={{
                                textTransform: 'uppercase',
                                fontSize: activeTab === tab ? '1.25rem' : '1rem', // Enlarged active tab
                                padding: '5px 15px',
                                whiteSpace: 'nowrap',
                                color: activeTab === tab ? 'black' : 'gray',
                                fontWeight: activeTab === tab ? 'bold' : 'normal',
                                border: 'none',
                                transition: 'all 0.3s ease',
                                background: activeTab === tab ? '#ffd700' : 'transparent',
                                cursor: 'pointer',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                position: activeTab === tab ? 'sticky' : 'relative', // Make active tab sticky
                                left: activeTab === tab ? 0 : 'auto', // Stick to the left
                                right: activeTab === tab && tab !== 'NEW' ? 0 : 'auto', // Stick to the right if it's not the first tab
                                zIndex: activeTab === tab ? 1 : 0 // Ensure it's above other tabs
                              }}
                            >
                              {cleanProfanity(tab)}
                            </button>
                          ))}


                        </div>
                      </div>

                      <div
                        ref={tabsRightArrowRef}
                        style={{
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: '10px', // Add space between tabs and arrow
                          minWidth: '40px', // Give it a fixed width
                          justifyContent: 'center',
                          transition: 'opacity 0.3s ease', // Smooth transition for opacity
                          opacity: 1, // Start visible, will be updated by effect
                        }}
                      >
                        <button
                          style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#ffd700',
                            fontSize: '1.5rem',
                            padding: '0 10px',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            const container = document.querySelector('.tabs-scroll-container');
                            container.scrollBy({ left: 300, behavior: 'smooth' });
                          }}
                        >
                          <i className="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {/* Only show navigation arrows when there are games to display */}
                {(validGames.length > 0 || nonEmptyFolders.length > 0) && (
                  <>
                    <button
                      className="games-left-arrow"
                      style={{
                        position: 'absolute',
                        left: '0px',
                        top: '33%',
                        transform: 'translateY(-50%)',
                        zIndex: 100,
                        // background: 'rgba(255,0,80,0.8)',
                        background: 'rgba(0, 0, 0, 0.5)',
                        border: '3px solid #57b047',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        cursor: 'pointer',
                        color: '#57b047',
                        fontSize: '1.5rem',
                        transition: 'opacity 0.3s ease', // Smooth transition for opacity
                        opacity: 1, // Start visible, will be updated by effect
                      }}
                      onClick={() => {
                        const container = document.querySelector('.games-scroll-container');
                        container.scrollBy({ left: -500, behavior: 'smooth' });
                      }}
                    >
                      <i className="fa-solid fa-chevron-left"></i>
                    </button>

                    <button
                      className="games-right-arrow"
                      style={{
                        position: 'absolute',
                        right: '0px',
                        top: '33%',
                        transform: 'translateY(-50%)',
                        zIndex: 100,
                        background: 'rgba(0, 0, 0, 0.5)',
                        border: '3px solid #57b047',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        cursor: 'pointer',
                        color: '#57b047',
                        fontSize: '1.5rem',
                        transition: 'opacity 0.3s ease', // Smooth transition for opacity
                        opacity: 1, // Start visible, will be updated by effect
                      }}
                      onClick={() => {
                        const container = document.querySelector('.games-scroll-container');
                        container.scrollBy({ left: 500, behavior: 'smooth' });
                      }}
                    >
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </>
                )}




                <div
                  className="games-scroll-container"
                  ref={gamesScrollContainerRef}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start', // Align items at the top instead of center
                    justifyContent: 'flex-start', // Start from the left
                    gap: `${Math.max(5, Math.floor(window.innerWidth * 0.005))}px`, // Dynamic gap based on screen width
                    width: 'calc(100% - 100px)',
                    flex: 1,
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    paddingLeft: '50px',
                    paddingTop: '10px', // Add padding at the top to create space between border and game summaries
                    marginBottom: '10px',
                    paddingBottom: '10px',
                    minHeight: (validGames.length > 0 || nonEmptyFolders.length > 0) ? '500px' : '250px', // Ensure consistent height abcdef
                    scrollbarColor: '#57b047 transparent',
                    scrollbarWidth: 'thin'
                  }}
                >
                  {isLoadingGames ? (
                    <div style={{
                      color: 'gold',
                      textAlign: 'center',
                      padding: '20px',
                      backgroundColor: 'rgba(0,0,0,0.3)',
                      borderRadius: '10px',
                      width: '350px',
                      height: '350px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto',
                      border: '1px solid gold',
                      boxShadow: '0 0 30px rgba(0,0,0,0.5)'
                    }}>
                      <div>
                        <div style={{ fontSize: '24px', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                          <img
                            src={chessslogo}
                            alt="Loading chess"
                            style={{
                              width: '75px',
                              height: 'auto',
                              animation: 'spin 2s linear infinite'
                            }}
                          />
                        </div>
                        <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Loading games...</p>
                        <style>
                          {`
                        @keyframes spin {
                          0% { transform: rotate(0deg); }
                          100% { transform: rotate(360deg); }
                        }
                      `}
                        </style>
                      </div>
                    </div>
                  ) : validGames.length === 0 && nonEmptyFolders.length === 0 ? (
                    <div style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '50px 40px',
                      backgroundColor: 'rgba(0,0,0,0.3)',
                      borderRadius: '12px',
                      boxShadow: '0 0 30px rgba(0,0,0,0.5)',
                      border: '1px solid gold',
                      margin: '0 50px',
                      minHeight: '300px',
                    }}>
                      <div style={{
                        color: 'gold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '15px 30px',
                        flexDirection: 'column',
                        fontSize: '30px',
                        fontWeight: 'bold',

                        width: '100%',
                        marginBottom: '25px',
                        borderRadius: '8px'
                      }}>
                        <i className="fa-solid fa-chess" style={{ fontSize: '50px', color: 'gold', marginBottom: '20px' }}></i>
                        No games available to display
                      </div>
                      <p style={{
                        fontSize: '1.2rem',
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: '30px',
                        lineHeight: '1.5'
                      }}>
                        {editProfile 
                          ? "You haven't posted any games or created any public bookmark folders yet."
                          : "This user hasn't posted any games or created any public bookmark folders yet."
                        }
                      </p>
                      <button
                        className=""
                        style={{
                          padding: '15px 30px',
                          backgroundColor: '#121212',
                          color: 'gold',
                          border: '3px solid gold',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontSize: '1.2rem',
                          fontWeight: 'bold',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
                        }}
                        onClick={() => {
                          if (editProfile) {
                            history.push('/Analysis');
                          } else {
                            history.push('/Portal');
                          }
                        }}
                      >
                        {editProfile ? 'Start Creating Chess Content' : 'Explore Chess Content'}
                      </button>
                    </div>
                  ) : activeTab === "ALL GAMES" ? (
                    /* Display all games with special styling for the first one */
                    validGames.map((game, index) => (
                      <div
                        key={game.id}
                        style={{
                          flex: '0 0 auto', // Prevent items from shrinking
                          display: 'flex',
                          alignItems: 'center', // Align at the top
                          justifyContent: 'center',
                          height: '100%' // Take full height of container
                        }}
                      >
                        <div
                          style={index === 0
                            ? {
                              // border: '2px solid #ff0050',
                              // background: 'linear-gradient(to top, #ff0050, black, gold)', // Very subtle gradient background
                              boxShadow: 'inset 0 0 15px rgba(255, 0, 80, 0.2), inset 0 0 25px rgba(255, 215, 0, 0.1)', // Inset shadow with pink and gold
                              padding: '15px',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center', // Align at the top
                              justifyContent: 'center'
                            }
                            : {
                              display: 'flex',
                              alignItems: 'center', // Align at the top
                              justifyContent: 'center',
                              padding: '15px',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center', // Align at the top
                              justifyContent: 'center',
                              border: '1px solid rgba(255,255,255,0.1)',

                            }
                          }
                        >
                          <GameSummary
                            gameData={game}
                            boardWidth={index === 0 ? 275 : 275}
                            onClick={() => {
                              // Update URL to include ALL GAMES navigation context
                              const url = `/games/${game.id}?fromAllGames=true&creatorId=${user}&gameIndex=${index}`;

                              window.location.href = url;
                            }}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    /* Display games from the selected folder */
                    currentFolderGames.length > 0 ? (
                      currentFolderGames.map((game, index) => (
                        <div
                          key={game.id}
                          style={{
                            flex: '0 0 auto', // Prevent items from shrinking
                            display: 'flex',
                            alignItems: 'center', // Align at the top
                            justifyContent: 'center',
                            height: '100%' // Take full height of container
                          }}
                        >
                          <div
                            style={index === 0
                              ? {
                                // border: '2px solid #ff0050',
                                // background: 'linear-gradient(to top, #ff0050, black, gold)', // Very subtle gradient background
                                boxShadow: 'inset 0 0 15px rgba(255, 0, 80, 0.2), inset 0 0 25px rgba(255, 215, 0, 0.1)', // Inset shadow with pink and gold
                                padding: '15px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center', // Align at the top
                                justifyContent: 'center'
                              }
                              : {
                                display: 'flex',
                                alignItems: 'center', // Align at the top
                                justifyContent: 'center',
                                padding: '15px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center', // Align at the top
                                justifyContent: 'center',
                                border: '1px solid rgba(255,255,255,0.1)',

                              }
                            }
                          >
                            <GameSummary
                              gameData={game}
                              boardWidth={275}
                              onClick={() => {
                                // Update the navigation to include folder context from profile
                                const url = `/games/${game.id}?fromProfile=true&profileUserId=${userId}&folderName=${encodeURIComponent(activeTab)}&folderIndex=${index}`;

                                window.location.href = url;
                              }}
                            />
                          </div>
                        </div>
                      ))
                    ) : (
                      // Show loading spinner when folder has no games yet
                      <div style={{
                        color: 'gold',
                        textAlign: 'center',
                        padding: '20px',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        borderRadius: '10px',
                        width: '350px',
                        height: '350px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                        border: '1px solid gold',
                        boxShadow: '0 0 30px rgba(0,0,0,0.5)'
                      }}>
                        <div>
                          <div style={{ fontSize: '24px', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                            <img
                              src={chessslogo}
                              alt="Loading chess"
                              style={{
                                width: '75px',
                                height: 'auto',
                                animation: 'spin 2s linear infinite'
                              }}
                            />
                          </div>
                          <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Loading folder games...</p>
                        </div>
                      </div>
                    )
                  )}

                </div>

                
                <div style={{}}>
                  {(validGames.length > 0 || nonEmptyFolders.length > 0) && (
                    <div style={{
                      position: 'relative',
                      width: '100%',
                      maxWidth: '100%',
                      margin: '5px auto',
                      display: 'flex',
                      alignItems: 'center',
                      height: '45px', // Increased height slightly
                      boxSizing: 'border-box',
                      justifyContent: 'center', // Center the entire tab container
                    }}>
                      <div
                        ref={bottomLeftArrowRef}
                        style={{
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          marginRight: '10px', // Add space between arrow and tabs
                          minWidth: '40px', // Give it a fixed width
                          justifyContent: 'center',
                          transition: 'opacity 0.3s ease', // Smooth transition for opacity
                          opacity: 1, // Start visible, will be updated by effect
                        }}
                      >


                      </div>




                    </div>
                  )}
                  
                </div>

              </div>



            </div>) :

            <>{tabs[tab]}

            </>}

        </main>

        {/* Share Profile Modal */}
        <ShareProfileModal
          isOpen={showShareProfileModal}
          onClose={() => setShowShareProfileModal(false)}
          shareLink={shareLink}
        />

        {/* Rate Limit Modal */}
        <RateLimitModal
          isVisible={showRateLimitModal}
          onClose={() => setShowRateLimitModal(false)}
        />

      </div >

    </div >
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getScreams })(Profile);